import { DesignSystem } from "../design-system.js";
import { DropdownTemplate } from "@fluentui/web-components";
import { styles as DropdownStyles } from "./dropdown.styles.js";
import { Dropdown } from "./dropdown.js";
/**
 * The Fabric Dropdown Element definition.
 *
 * @public
 * @remarks
 * HTML Element: `<fabric-dropdown>`
 */
export const definition = Dropdown.compose({
    name: `${DesignSystem.prefix}-dropdown`,
    template: DropdownTemplate,
    styles: DropdownStyles,
    shadowOptions: {
        delegatesFocus: true
    }
});
//# sourceMappingURL=dropdown.definition.js.map